import React, { useContext } from 'react';
import { HeadingLevelContext } from '../context';
/**
 * Render a heading that matches the level of the current heading level context
 */ const Heading = (props)=>{
    const headingLevel = useContext(HeadingLevelContext);
    // Keep the heading level from going above 6
    // But keep it from going below 2 -- we want h1s to be explicit to avoid any mess ups
    const Tag = `h${Math.max(Math.min(headingLevel, 6), 2)}`;
    return /*#__PURE__*/ React.createElement(Tag, props);
};
Heading.displayName = 'Heading';
export default Heading;
